(function (angular) {
    'use strict';

    angular.module('reports')

        .controller('HistoricChatCtrl', ['$scope', 'chartFactoryService', '$stateParams', 'teamSettingsService', 'chatAnalyticsService', 'jwtService', 'usersService', 'historicChatReportingService', 'sharedChartService',
            function ($scope, chartFactoryService, $stateParams, teamSettingsService, chatAnalyticsService, jwtService, usersService, historicChatReportingService, sharedChartService) {

                var chatConfig;
                var period = "day";

                $scope.hasData = false;

                Chart.pluginService.register(chartFactoryService.fillScatteredTimeScaleDataPlugin);


                $scope.onTeamChanged = function () {

                    if ($scope.from) {
                        getData();
                    }

                };


                $scope.onDateRangeChange = function (from, to) {
                    $scope.from = from;
                    $scope.to = to;

                    if ($scope.currentTeam) {
                        getData();
                    }

                };

                var ctx = {};
                var charts = {};
                var _users;

                /**
                 * dynamic x axis units based on the time-range ...
                 * @param {*} from 
                 * @param {*} to 
                 */
                function getTimeUnits(from, to) {

                    var dFrom = new Date(from);
                    var dTo = new Date(to);
                    var by;
                    var days = (dTo.getTime() - dFrom.getTime()) / (24 * 60 * 60 * 1000);
                    if (days < 3) {
                        by = 'hour';
                    }
                    else if (days <= 180 && days >= 3) {
                        by = 'day';
                    }
                    else if (days >= 180 && days < 1095) {
                        by = 'month';
                    }
                    else {
                        by = 'year';
                    }
                    return by;
                }


                /**
                 * 
                 * @param {*} data 
                 */
                function renderLineChart(data) {

                    // crater existing graph ...
                    if (charts.line) {
                        charts.line.destroy();
                        charts.line = undefined;
                    }

                    var maxYvalue = 0;
                    if (data.datasets) {
                        data.datasets.forEach(function (dataset) {
                            if (dataset.data) {
                                dataset.data.forEach(function (el) {
                                    maxYvalue = maxYvalue > el.y ? maxYvalue : el.y;
                                });
                            }
                        });
                    }
                    maxYvalue *= 1.05;

                    charts.line = new Chart(ctx.line, {
                        type: "line",
                        data: {
                            // labels: data.labels,
                            datasets: data.datasets
                        },
                        options: {
                            plugins: {
                                datalabels: {
                                    display: false
                                }
                            },
                            legend: {
                                position: "right",
                                labels: {
                                    usePointStyle: true,
                                }
                            },
                            scales: {

                                xAxes: [{
                                    type: 'time',
                                    distribution: 'linear',
                                    gridLines: {
                                        display: false
                                    },
                                    time:
                                    {
                                        unit: getTimeUnits($scope.from, $scope.to),
                                        min: $scope.from,
                                        max: $scope.to,
                                        fillGapsWithZero: true
                                    },
                                }],
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true,
                                        max: maxYvalue,
                                        userCallback: function (label, index, labels) {
                                            // when the floored value is the same as the value we have a whole number
                                            if (Math.floor(label) === label) {
                                                return label;
                                            }

                                        },
                                    }
                                }],
                            },
                            responsive: true,
                            title: {
                                display: true,
                                text: 'Opened / Closed Chats',
                            },
                            tooltips: {
                                mode: 'index',
                                intersect: false,
                                callbacks: {
                                    title: function (tooltipItem, chart) {
                                        if (tooltipItem && tooltipItem[0]) {
                                            tooltipItem = tooltipItem[0];
                                            switch (period) {
                                                case 'hour':
                                                    return moment(tooltipItem.xLabel).format('HH:mm');

                                                case 'day':
                                                    return moment(tooltipItem.xLabel).format('DD/M/YYYY');

                                                case 'month':
                                                    return moment(tooltipItem.xLabel).format('M/YYYY');

                                                default:
                                                    return moment(tooltipItem.xLabel).format('M/YYYY');

                                            }
                                        }

                                    },
                                }
                            },
                            hover: {
                                mode: 'nearest',
                                intersect: true
                            },
                        }
                    });

                }


                /**
                 * 
                 * @param {*} data 
                 */
                function renderDoughnutChart(data) {
                    // crater existing graph ...
                    if (charts.doughnut) {
                        charts.doughnut.destroy();
                        charts.doughnut = undefined;
                    }

                    charts.doughnut = new Chart(ctx.doughnut, {
                        type: "pie",
                        data: {
                            labels: data.labels,
                            datasets: [{
                                data: data.data,
                                backgroundColor: data.colors,
                                label: 'Channel split',
                            }]
                        },
                        options: {
                            plugins: {
                                datalabels: {
                                    display: false
                                }
                            },
                            responsive: true,
                            legend: {
                                position: "right",
                                labels: {
                                    usePointStyle: true
                                },
                                onClick: function (e) { e.stopPropagation() }
                            },
                            title: {
                                display: true,
                                text: 'Channel Breakdown'
                            },
                            animation: {
                                animateScale: true,
                                animateRotate: true
                            },
                            tooltips: {
                                callbacks: {
                                    label: function (tooltipItem, data) {
                                        var dataset = data.datasets[tooltipItem.datasetIndex];
                                        var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                            return previousValue + currentValue;
                                        });
                                        var currentValue = dataset.data[tooltipItem.index];
                                        var percentage = Math.floor((currentValue / total) * 100);
                                        return data.labels[tooltipItem.index] + " " + currentValue + " (" + percentage + "%)";
                                    }
                                }
                            }
                        }
                    });
                }

                function getData() {

                    $scope.hasData = false;

                    // reset the 2 charts ...
                    renderLineChart({
                        dataSets: []
                    });

                    renderDoughnutChart({
                        labels: [],
                        data: [],
                        colors: []
                    });

                    chatAnalyticsService.getHistoricData($stateParams.pickedApiSpaceId, $scope.from, $scope.to, $scope.currentTeam)
                        .then(function (result) {
                            $scope.data = result;
                            period = result.period;

                            if (result.length) {
                                $scope.hasData = true;

                                var lineData = historicChatReportingService.buildOpenClosedOverTimeData(result);

                                renderLineChart(lineData);

                                // what are the available channels for this team ?
                                var currentTeam = chatConfig.teams.find(function (team) {
                                    return team.teamId === $scope.currentTeam
                                });

                                var pieData = historicChatReportingService.buildChannelBreakdownData(currentTeam, result);

                                renderDoughnutChart(pieData);

                                $scope.tableRows = historicChatReportingService.buildAgentBreakdownData(_users, result);
                            }

                        })
                        .catch(function (error) {
                            console.error("chatAnalyticsService.getHistoricData()", error);
                            $scope.data = error;
                        });
                }

                function initialise() {

                    // initialise line & pie charts
                    ctx.line = document.getElementById('lineChart');
                    ctx.doughnut = document.getElementById('doghnutChart');

                    // get list of teams and agents

                    return usersService.getUsers(jwtService.payload.accountId)
                        .then(function (users) {
                            _users = users;
                            return teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId)
                        })
                        .then(function (config) {
                            chatConfig = config;
                            return teamSettingsService.getTeams($stateParams.pickedApiSpaceId)
                        })
                        .then(function (result) {

                            $scope.teams = result;

                            if ($scope.teams.length) {
                                var savedTeamId = sharedChartService.initialiseWatch($scope, "currentTeam", $stateParams.pickedApiSpaceId, "HistoricChatCtrl");
                                var savedTeam = $scope.teams.find(function (team) {
                                    return team.id === savedTeamId;
                                });
                                $scope.currentTeam = savedTeam ? savedTeamId : $scope.teams[0].id;
                                // trigger one of these so the data will load
                                $scope.onTeamChanged();
                            }

                        });
                }

                initialise();

            }]);
})(window.angular);